import { render, staticRenderFns } from "./FinanceCenter.vue?vue&type=template&id=508dcd0e&scoped=true"
import script from "./FinanceCenter.vue?vue&type=script&lang=js"
export * from "./FinanceCenter.vue?vue&type=script&lang=js"
import style0 from "./FinanceCenter.vue?vue&type=style&index=0&id=508dcd0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508dcd0e",
  null
  
)

export default component.exports